import PageWrapper from "@/pages/PageWrapper";
import CTA from "@/sections/CTA";
import useSEO from "@/lib/useSEO";

export default function ContactPage() {
    useSEO({
        title: "Contact ate.teen studio — Start Your Project in Kollam, Kerala",
        description:
            "Reach ate.teen studio in Kollam, Kerala to start your villa, interior, commercial or renovation project. We reply within one working day.",
        path: "/contact",
    });
    return (
        <PageWrapper className="pt-24">
            <h1 className="sr-only">
                Contact ate.teen studio in Kollam, Kerala to start your architecture project
            </h1>
            <CTA />
        </PageWrapper>
    );
}
